import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  {
    path: "/two",
    name: "Two",
    component:() => import('../views/two.vue')
  },
  {
    path: "/three",
    name: "Three",
    component:() => import('../views/three.vue')
  },
  {
    path: "/four",
    name: "Four",
    component:() => import('../views/four.vue')
  },
  {
    path: "/five",
    name: "Five",
    component:() => import('../views/five.vue')
  },
  {
    path: "/six",
    name: "Six",
    component:() => import('../views/six.vue')
  },
]
const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
})

export default router